<div class="page">
  <div class="header">
    <div class="header-title">
      <mat-icon>admin_panel_settings</mat-icon>
      <span>Admin tools</span>
    </div>
  </div>
  <mat-card class="content">
    <h3>Omgevingen en inrichting</h3>
    <button mat-flat-button type="button" (click)="newOrganisation()" class="tool-button">
      <mat-icon>add</mat-icon>
      Nieuwe omgeving aanmaken
    </button>
    <button mat-flat-button type="button" (click)="manageParticularities()" class="tool-button">
      <mat-icon>settings_accessibility</mat-icon>
      Bijzonderheden beheren
    </button>

    <h3>Accounts en toegangsbeheer</h3>
    <button mat-flat-button type="button" (click)="adjustPassword()" class="tool-button">
      <mat-icon>manage_accounts</mat-icon>
      Wachtwoord van een account veranderen
    </button>
    <button mat-flat-button type="button" (click)="addUserToOrgs()" class="tool-button">
      <mat-icon>group_add</mat-icon>
      Superusers organisaties beheren
    </button>

    <h3>Betalingen</h3>
    <button mat-flat-button type="button" class="tool-button" routerLink="/admin-tools/setup-payment-methods">
      <mat-icon>payments</mat-icon>
      Betaalmethodes instellen
    </button>
    <button mat-flat-button type="button" (click)="generateSepas()" class="tool-button">
      <mat-icon>attach_money</mat-icon>
      SEPA genereren voor Buurtvervoerders
    </button>

    <h3>Gegevens opschonen</h3>
    <button mat-flat-button type="button" (click)="deleteRides()" class="tool-button">
      <mat-icon>delete</mat-icon>
      Ritten binnen een range verwijderen
    </button>
    <button mat-flat-button type="button" (click)="cleanOrphanedOrganisationUsers()" class="tool-button">
      <mat-icon>person_remove</mat-icon>
      Gebruikers verwijderde organisatie verwijderen
    </button>
    <button mat-flat-button type="button" (click)="bulkDeleteHiddenPassengers()" class="tool-button">
      <mat-icon>group_off</mat-icon>
      Oude passagiers verwijderen
    </button>
  </mat-card>
</div>
